import React, {memo} from 'react'
import {OASUI, RedocUI} from './versions/docs'
import {withContractForPublishedDocData, withErrorHandling, withHelmet, withQueryParams} from '../../hoc'

const _PublishedDocs = (
  {
    notFound = false,
    display = '',
    contract
  }
) => {
  if (notFound) {
    return (<div>No docs found</div>)
  }
  return (
    <div data-testid='published-docs'>
      {
        display.indexOf('api-docs') > -1 && (<RedocUI contract={contract}/>)
      }
      {
        display.indexOf('swagger-docs') > -1 && (<OASUI contract={contract}/>)
      }
    </div>
  )
}

let PublishedDocs = (props) => {
  return (<_PublishedDocs {...props}/>)
}

PublishedDocs = withHelmet(PublishedDocs, 'Published Docs')
PublishedDocs = withContractForPublishedDocData(PublishedDocs, 'Loading contract...')
PublishedDocs = withQueryParams(PublishedDocs)
PublishedDocs = withErrorHandling(PublishedDocs)
PublishedDocs = memo(PublishedDocs)

export {_PublishedDocs, PublishedDocs}

export default PublishedDocs